import axios from '../../plugins/axios'

export const listUsers = ({ commit }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get('/api/user', config)
    .then((response) => {
        const users = response.data
        commit('SET_USERS', { users })
        return response
      },
      (error) => {
        commit('SET_USERS', { users: [] })
        console.error(error)
      }
    )
}

export const createUser = ({ commit }, data ) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/api/user', data ,config)
    .then((response) => {
        listUsers({ commit })
        return response
      },
      (error) => {
        console.log(error)
        return error.response
      }
    )
}

export const deleteUser = ({ commit }, id ) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.delete(`/api/user/${id}`, config)
    .then((response) => {
        listUsers({ commit })
        return response
      },
      (error) => {
        console.error(error)
      }
    )
}

export const updateUser = ({ commit }, data ) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/api/user/${data.id}`, data ,config)
    .then((response) => {
        listUsers({ commit })
        return response
      },
      (error) => {
        console.error(error)
      }
    )
}

export const addNotificationToken = ({ }, data ) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/api/user/me/notification-token', data ,config)
    .then((response) => response, (error) => console.error(error))
}